import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'
import { COLORS, BREAKPOINTS, fadeIn } from '../GlobalStyles'
import budgie from '../assets/budgie-thumbnail.png'
import bookish from '../assets/bookish-thumbnail.svg'
import plantgeekApp from '../assets/plantgeek-thumbnail.svg'
import creatorco from '../assets/creatorco-thumbnail.png'
import deaflink from '../assets/deaflink-thumbnail.svg'
import swetz from '../assets/swetz-thumbnail.svg'
import ticketWidget from '../assets/ticket-widget-thumbnail.svg'
import plantgeek from '../assets/plantgeek-thumbnail1.svg'
import sushiHeaven from '../assets/sushi-heaven-thumbnail.svg'
import { ImageLoader } from '../components/ImageLoader'

  const ProjectCard = ({ project }) => {
    return (
      <Link to={`/projects/${project.path}`} className='project-card'>
        <div className='thumbnail'>
          <ImageLoader src={project.thumbnail} alt='' borderRadius='20px 20px 0 0' />
        </div>
        <div className='text'>
          <h3 className='title'>
            [ <b>{project.title}</b> ]
          </h3>
          <p className='summary'>{project.summary}</p>
          <div>
            <p className='type'>{project.type}, {project.device}</p>
            <p className='role'>{project.role}</p>
          </div>
        </div>
      </Link>
    )
  }

export const Projects = () => {
  // makes window scroll to top between renders
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

const devProjects = [
  {
    path: 'budgie',
    thumbnail: budgie,
    title: 'Budgie',
    summary: 'A personal finance dashboard for budgeting and tracking expenses.',
    type: 'Full Stack Development',
    device: 'Web App',
    role: 'Collaborative Project • 2024',
  },
  {
    path: 'bookish',
    thumbnail: bookish,
    title: 'bookish',
    summary: 'A library tracker and discovery app to help you find your next read.',
    type: 'Full Stack Development',
    device: 'Mobile App',
    role: 'Solo Project • Apr - May 2023',
  },
  {
    path: 'plantgeek-app',
    thumbnail: plantgeekApp,
    title: 'plantgeek mobile',
    summary: 'A plant-care app that helps manage your collection and sends watering reminders.',
    type: 'Full Stack Development',
    device: 'Mobile App',
    role: 'Solo Project • Jan - Feb 2023',
  },
  {
    path: 'creatorco',
    thumbnail: creatorco,
    title: 'Creator',
    summary: 'A revamped brand site for a social-media marketing platform.',
    type: 'Frontend Development',
    device: 'Responsive Website',
    role: 'Sole Developer • Jan 2023',
  },
  {
    path: 'plantgeek',
    thumbnail: plantgeek,
    title: 'plantgeek web',
    summary: 'A plant-care platform featuring hundreds of houseplants and advanced search.',
    type: 'Full Stack Development',
    device: 'Web App',
    role: 'Solo Project • 2021 - 2022',
  },
  {
    path: 'sushi-heaven',
    thumbnail: sushiHeaven,
    title: 'Sushi Heaven',
    summary: 'An aesthetic browser game inspired by Cookie Clicker.',
    type: 'Frontend Development',
    device: 'JavaScript Game',
    role: 'Solo Project • Mar 2021',
  },
]

const designProjects = [
  {
    path: 'deaflink',
    thumbnail: deaflink,
    title: 'deafLINK',
    summary: 'A social platform for the Deaf community to connect and organize events.',
    type: 'UX Design',
    device: 'Mobile App & Website',
    role: 'Solo Project • Oct - Nov 2022',
  },
  {
    path: 'swetz',
    thumbnail: swetz,
    title: 'SWETZ',
    summary: 'A shopping site for custom sweatshirts and hoodies with a smooth checkout flow.',
    type: 'UX Design',
    device: 'Responsive Website',
    role: 'Solo Project • Aug - Sep 2022',
  },
  {
    path: 'ticket-widget',
    thumbnail: ticketWidget,
    title: 'TicketWidget',
    summary: 'A concert ticket booking app focused on an intuitive user experience.',
    type: 'UX Design',
    device: 'Mobile App',
    role: 'Solo Project • May - Aug 2022',
  },
]


  return (
    <Wrapper>
      <div className='page-inner'>
        <div className='section-header'>
          <h2>Development Projects</h2>
          <div className='tags'>
            <span className='tag'>HTML5</span>
            <span className='tag'>CSS3 / SCSS</span>
            <span className='tag'>JavaScript</span>
            <span className='tag'>TypeScript</span>
            <span className='tag'>React / React Native</span>
            <span className='tag'>Node.js</span>
            <span className='tag'>Express.js</span>
            <span className='tag'>Prisma</span>
            <span className='tag'>PostgreSQL</span>
            <span className='tag'>MongoDB</span>
          </div>
        </div>

        <div className='project-grid'>
          {devProjects.map((project, index) => (
            <ProjectCard project={project} key={index} />
          ))}
        </div>

        <div className='section-header'>
          <h2>Design Projects</h2>
          <div className='tags'>
            <span className='tag'>UX / UI</span>
            <span className='tag'>Figma</span>
            <span className='tag'>Adobe XD</span>
            <span className='tag'>Wireframes</span>
            <span className='tag'>Prototypes</span>
            <span className='tag'>User Journeys</span>
          </div>
        </div>
        <div className='project-grid'>
          {designProjects.map((project, index) => (
            <ProjectCard project={project} key={index} />
          ))}
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.main`
  flex: 1;
  min-height: 100vh;
  .page-inner {
    padding: 100px 20px 40px 20px;
    max-width: 1400px;
    margin: auto;
    display: flex;
    flex-direction: column;
  }
  h2 {
    font-weight: bold;
    font-size: 1.4rem;
    color: ${COLORS.primaryAccent};
  }
  .section-header {
    margin-bottom: 40px;
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
    .tag {
      border: 1px solid #ccc;
      padding: 10px 20px 8px 20px;
      font-size: 0.7rem;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }
  .project-grid {
    width: 100%;
    max-width: 1400px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    margin: auto;
    padding-bottom: 80px;
    .project-card {
      animation: ${fadeIn} 1s ease-in-out;
      background: #fff;
      box-shadow: 3px 5px 20px rgba(0, 0, 0, 0.1);
      border-radius: 20px;
      cursor: pointer;
      transition: 0.2s ease-in-out;
      // prevent hover effect on touch screens
      @media (hover: hover) {
        &:hover {
          transform: translate(0, -10px);
          box-shadow: 3px 5px 30px rgba(0, 0, 0, 0.2);
        }
      }
      .thumbnail {
        width: 100%;
        height: 200px;
        overflow: hidden;
      }
      .text {
        padding: 20px;
        color: #666;
        display: flex;
        flex-direction: column;
        gap: 20px;
        .title {
          color: ${COLORS.dark};
        }
        .summary {
          font-size: 0.9rem;
        }
        .type {
          font-weight: bold;
        }
        .role {
          font-size: 0.8rem;
          color: #999;
        }
      }
    }
  }
  @media only screen and (min-width: ${BREAKPOINTS.tablet}) {
    .project-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 40px;
    }
  }
  @media only screen and (min-width: ${BREAKPOINTS.desktop}) {
    .project-grid {
      grid-template-columns: repeat(3, 1fr);
      gap: 50px;
      .project-card .thumbnail {
        min-height: 250px;
      }
    }
  }
`
